import { fetcher } from "@/lib/api/fetcher";
import { environments } from "@/lib/config";
import { ResponseData } from "@/types/common";
import {
  NotificationContentType,
  NotificationListQuery,
  PaginationNotificationContentType,
} from "@/types/notifications";

const apiUrl = environments.restApiUrl;

export const getNotificationList = (
  queryParams: NotificationListQuery = {}
) => {
  return fetcher<ResponseData<PaginationNotificationContentType>>(
    `${apiUrl}/notification`,
    {
      queryParams,
    }
  );
};

export const markNotificationsSeen = ({
  notificationIds,
  isMarkAll = false,
}: {
  notificationIds?: Array<number | string>;
  isMarkAll?: boolean;
}) => {
  return fetcher(`${apiUrl}/notification/seen`, {
    method: "POST",
    body: {
      // normalize ids to strings if present
      notification_ids: notificationIds?.map(String) ?? [],
      is_mark_all_seen: isMarkAll,
    },
  });
};

export const getNotificationDetail = (notificationId: number) => {
  return fetcher<ResponseData<NotificationContentType>>(
    `${apiUrl}/notification/${notificationId}`
  );
};
